<page-header
        icon="{{['PRIORITIZED', 'SUMMARY'] | monIcons}}"
        header="{{'Prioritized Pages' | translate}}"
        subHeader="{{ subheaderTranslation }}">
</page-header>
<mon-tabs
        [options]="tabs"
        [(status)]="activeTab"
        (onSearch)="onSearch($event)"
        (onStatus)="onStatus($event)"
        [search]="search"
        [minSearchLength]="1"
        [showSearch]="true"
        [showFiltersBtn]="showFilters"
        [(isFiltersOpen)]="isFiltersOpen">
</mon-tabs>
<div class="card panel-monsido-card">
    <div class="card-body">
        <pages-table
                [pages]="pages"
                (onPageSort)="onSortPage($event.direction, $event.by)"
                (onPageChange)="onPageChange($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                [tab]="activeTab"
                [currentSort]="currentSort"
                [progress]="promise"
                [(isFiltersOpen)]="isFiltersOpen"
                ref="base.customer.domain.pages.index"
                (onFiltersChanges)="onFiltersChanges($event)">
        </pages-table>
    </div>
</div>
